import { Component, ElementRef, OnInit, ViewChild, viewChild, ChangeDetectorRef  } from '@angular/core';
import { MassCommunicationService } from './mass-communication.service'; // Import the service
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent, MAT_CHIPS_DEFAULT_OPTIONS, } from '@angular/material/chips';
import { ENTER } from '@angular/cdk/keycodes';
import { of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, take } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { CommonModelService } from '../padu-reporting/capability/common-model.service';
import { OptimizeService } from '../shared/optimize.service';
import { SharedAuthService } from '../shared/shared.auth.service';
import { environment } from '../../environments/environment';
import { NgForm } from '@angular/forms';

export interface templateDetails {
  accessId: string;
  createdBy: string;
  createdAt: string;
  result: string;
  templateName: string;
  htmlContent: string;
  templateId: string;
  name: string;
  environment: string;
  dbInstance: string;
}

export interface EmailPayload {
  templateName: string;
  html: string;
  communityName: string;
  bccGroup: string;
  ccGroup: string;
  subject: string;
  mask_message: string;
  MSID: string;
  dbInstance: string;
  attachments?: File[]; // New property for attachments
}
export interface TemplatePayload {
  templateName: string;
  html: string;
  accessId: string;
  MSID: string;
  environment: string;
  dbInstance: string;
}
@Component({
  selector: 'app-mass-communication',
  templateUrl: './mass-communication.component.html',
  styleUrls: ['./mass-communication.component.scss'],
  standalone: false,
  providers: [{
    provide: MAT_CHIPS_DEFAULT_OPTIONS,
    useValue: {
      separatorKeyCodes: [ENTER]
    }
  }]
})
export class MassCommunicationComponent implements OnInit {
  public editorConfig = {
    licenseKey: '',
    toolbar: [
      'undo', 'redo', '|',
      'heading', '|',
      'bold', 'italic', 'underline', 'strikethrough', '|',
      'link', 'bulletedList', 'numberedList', '|',
      'blockQuote', 'insertTable', 'mediaEmbed', '|',
      'imageInsert','editableToolbar', 'codeBlock', '|',
    ],
  };
  maskingMsg: string = '';
  templates: templateDetails[] = []; // Initialize templates as an empty array
  disableEmailButton: boolean = true;
  updatedContent: string = '';
  selectedTemplate: any = '';
  messageContent: any = '';
  prevMessageContent: string = '';
  cmgrpList: any[] = [];
  createNewTemplateFlag: boolean = false;
  templateName: string = '';
  selectedCommunity: any[] = []; // array of selected items
  selectedBcc: any[] = []; // array of selected items bcc
  selectedCc: any[] = []; // array of selected items cc
  cmSubject: string = ''; // Subject for the communication
  disableUpdateButton: boolean = true; // Flag to disable the update button
  readonly separatorKeysCodes: number[] = [ENTER];
  subject = new Subject<string>();
  selectedUsers: any[] = []; // Array to hold previously selected users
  searchUserList: any[] = []; // Array to hold search results
  @ViewChild('inputAddOwner', { static: false }) inputAddOwner: any; // Reference to the input element for user search
  disableCreateButton: boolean = true; // Flag to disable the create button
  communicationPortalAccess: boolean;
  envVal = environment.environmentName;
  selectedFiles: File[] = [];
  //  selectedFiles: File | null = null;
  
@ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
@ViewChild('emailForm') emailForm!: NgForm;



  constructor( private optimize: OptimizeService,private massCommunicationService: MassCommunicationService,private toasterService:ToastrService, private capabilityService: CommonModelService,private sharedAuthService: SharedAuthService,
    private cdr: ChangeDetectorRef
  ) {} // Inject the service

  ngOnInit(): void {
    this.initialiseData();
  }

  initialiseData(): void {
     if (!sessionStorage.getItem('techaccessData')) {
          this.sharedAuthService.userAccessDataSource.pipe(take(1)).subscribe(accessData => {
            this.checkForUserAccess();
          });
        } else {
           this.checkForUserAccess();
        }
    
  }
  checkForUserAccess(){
    this.communicationPortalAccess  = this.sharedAuthService.getTohPageAccessDetails('CommunicationPortal','View') || this.sharedAuthService.getTohPageAccessDetails('CommunicationPortal','Edit');
    if(this.communicationPortalAccess){
      this.setUpSubject(); // Set up the subject for user search
      this.getTemplates(); // Fetch the templates from the service
      this.getGroupList();
    }
  }

  //Function to get the list of templates
  getTemplates(){
    const msid = this.sharedAuthService.getMsid();
    this.massCommunicationService.getTemplates(msid).subscribe(
      response => {
        if (response && response.length > 0) {
          const templates: Array<templateDetails> = response;
          templates.forEach(template => {
            template.name = template.templateName;
          });
          this.templates = templates;
        }
      },
      error => {
        console.error('Error fetching templates:', error);
      }
    )
  }

  // Function to get the list of communities (groups)
  getGroupList(){
    this.massCommunicationService.getCommunityList().subscribe(
      response => {
        if(response && response.length > 0) {
          response.forEach(group => {
            group.name = group.communityName; // Assuming communityName is the field you want to display
          });
          this.cmgrpList = response;
        } 
      },
      error => {
        console.error('Error fetching group list:', error);
      }
    );
  }

  // Function called when template is selected from the dropdown
  onTemplateChange(template: templateDetails): void {
    this.selectedTemplate = template;
    this.messageContent = template.htmlContent;
    this.prevMessageContent = template.htmlContent; // Store the previous message content
    this.selectedUsers = template.accessId ? template.accessId.split(',').map(user => {return {msid:user}}) : [];
    this.updatedContent = template.htmlContent ? template.htmlContent : ''; // Set the updated content for the editor
    this.validateButtons(); // Validate buttons after template selection
  }

  
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFiles = Array.from(input.files); // Convert FileList to Array
    }
  }

   buildEmailPayload(): EmailPayload {
    const msid = this.sharedAuthService.getMsid();
    if (!msid) {
      this.toasterService.error('User session expired or invalid. Please log in again.', '', { timeOut: 10000, positionClass: 'toast-top-center' });
      return null as any;
    }
    return {
      templateName: this.selectedTemplate?.templateName,
      html: this.updatedContent,
      communityName: this.selectedCommunity.map(c => c.name).join(),
      bccGroup: this.selectedBcc.map(c => c.name).join(),
      ccGroup: this.selectedCc.map(c => c.name).join(),
      subject: this.cmSubject,
      mask_message: this.maskingMsg,
      MSID: msid,
      dbInstance: this.envVal != 'Prod' ? this.envVal : '',
      attachments: this.selectedFiles // Include selected files here
    };
  }
  buildTemplatePayload(isCreate: boolean  = true): TemplatePayload {
    const msid = this.sharedAuthService.getMsid();
    if (!msid) {
      this.toasterService.error('User session expired or invalid. Please log in again.', '', { timeOut: 10000, positionClass: 'toast-top-center' });
      return null as any;
    }
    let templateName = '';
    if(isCreate){
      templateName = this.templateName;
    }else{
      templateName = this.selectedTemplate?.templateName;
    }
    return {
      templateName: templateName,
      html: this.updatedContent,
      accessId: this.selectedUsers.map(user => user.msid).join(',') ,
      MSID: msid,
      environment: this.envVal,
      dbInstance: this.envVal != 'Prod' ? this.envVal : ''
    };
  }

  sendEmail() {
    if (this.selectedTemplate && this.updatedContent) {
      const payload = this.buildEmailPayload();
      this.massCommunicationService.sendEmail(payload).subscribe(
        response => {
          if(response) {
            this.toasterService.success('Email sent successfully', '', { timeOut: 10000, positionClass: 'toast-top-center' });
 
          this.cmgrpList = [];
          this.getGroupList();

          this.templates= [];
          this.getTemplates();
          this.clearFields(); // Reset selected template after sending email
          }
        },
        error => {
          console.error('Error sending email:', error);
          this.toasterService.error('Failed to send email', '', { timeOut: 10000, positionClass: 'toast-top-center' });
        }
      );
    } else {
      alert('Please select a template and enter a message.');
    }
  }

  createTemplate(){
    const templatePayload = this.buildTemplatePayload(true);
    this.massCommunicationService.createTemplate(templatePayload).subscribe(
      response => {
        if(response) {
          this.toasterService.success('Template created successfully', '', { timeOut: 10000, positionClass: 'toast-top-center' });
          this.getTemplates();
          this.createNewTemplateFlag = false;
          this.clearFields();
        }else{
          this.toasterService.error(response.message, '', { timeOut: 10000, positionClass: 'toast-top-center' });
        }
      },
      error => {
        console.error('Error fetching group list:', error);
        this.toasterService.error(error.error.message, '', { timeOut: 10000, positionClass: 'toast-top-center' });
      }
    );
  }

  updateTemplate(){
    const payload = this.buildTemplatePayload(false);
    this.massCommunicationService.updateTemplate(payload).subscribe(
      response => {
        if(response) {
          this.toasterService.success('Template updated successfully', '', { timeOut: 10000, positionClass: 'toast-top-center' });
          this.getTemplates(); // Refresh the templates list
          this.clearFields(); // Clear fields after updating
        }
      },
      error => {
        console.error('Updation Failed! ', error);
        this.toasterService.error('Failed to update template', '', { timeOut: 10000, positionClass: 'toast-top-center' });
      }
    );
  }

  clearFields() {
     this.emailForm.resetForm();        // resets bound controls
    this.selectedFiles = [];           // reset file array
    this.fileInput.nativeElement.value = ''; // resets actual file input UI
    this.selectedTemplate = '';
    this.messageContent = '';
    this.maskingMsg = '';
    this.templateName = '';
    this.cmSubject = ''; // Reset the subject for the communication
    this.selectedUsers = []; // Reset selected users when creating a new template
    this.disableCreateButton = true; // Disable the create button initially
    this.disableEmailButton = true; // Disable the email button initially
    this.disableUpdateButton = true; // Disable the update button initially
    this.prevMessageContent = ''; // Reset previous message content
    this.selectedCommunity = []; // Reset selected community
    this.selectedBcc = []; // Reset selected BCC
    this.selectedCc = []; // Reset selected CC
    this.updatedContent = ''; // Reset updated content
    this.cdr.detectChanges();
  }

  checkExistUser(user){
    // Check if the user already exists in the selectedUsers array
    return this.selectedUsers.some(selectedUser => selectedUser.msid === user.msid);
  }

  createNewTemplate() {
    this.createNewTemplateFlag = !this.createNewTemplateFlag;
    this.clearFields(); // Clear fields when creating a new template
  }

  onCommunityChange(event: any[]) {
    this.selectedCommunity = event || [];
    this.validateButtons(); // Validate buttons after community selection
  }

   onBccChange(event: any[]) {
    this.selectedBcc = event || [];
    this.validateButtons(); // Validate buttons after community selection
  }

   onCcChange(event: any[]) {
    this.selectedCc = event || [];
    this.validateButtons(); // Validate buttons after community selection
  }

  onEditorChanges() {
    this.validateButtons(); // Validate buttons after editor changes
  }

  remove(msid: any): void {
    const index = this.selectedUsers.findIndex(user => user.msid === msid);
    if (index >= 0) {
      this.selectedUsers.splice(index, 1);
    }
    this.validateButtons(); // Validate buttons after removing a user
  }

  validationForCreateButton() {
    // Check if the template name and message content are valid
    if (this.templateName && this.updatedContent && this.selectedUsers.length > 0) {
      this.disableCreateButton = false; // Enable the create button
    } else {
      this.disableCreateButton = true; // Disable the create button
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.selectedUsers.push({
      givenName: event.option.value.givenName,
      mail: event.option.value.mail,
      displayName: event.option.value.displayName,
      employeeID: event.option.value.employeeID,
      msid: event.option.value.cn,
    });
    this.inputAddOwner.nativeElement.value = ''; // Clear the input field after selection
    this.validateButtons(); // Validate buttons after selection
  }

  //Function to set up the subject for the search user
  setUpSubject() {
    this.subject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(() => this.getSearchedUser().pipe(
        catchError(error => {
          this.toasterService.error('Failed to load LDAP users', '', { timeOut: 10000, positionClass: 'toast-top-center' });
          return of([]);
        })
      ))
    ).subscribe((users) => {
      this.searchUserList = users;
    },
      error => {
        // Handle error scenario
        this.toasterService.error('Failed to load LDAP users', '', { timeOut: 10000, positionClass: 'toast-top-center' });
      });
  }


  keyUpSearch(name) {
    const val = name.target.value.trim();
    if (val && val.length >= 3) {
      this.subject.next(val);
    }
  }

  focusOnInput() {
    this.inputAddOwner.nativeElement.focus();
  }

  // Get the searched user from the LDAP API
  getSearchedUser() {
    const searchTerm = this.inputAddOwner.nativeElement.value.trim();
    return this.capabilityService.getLDAPUsers(searchTerm);
  }

  onInputFieldChanged(): void {
    this.validateButtons();
  }

  validationForEmailButton(): void {
    // Check if the selected template and message content are valid
    if (this.selectedTemplate?.templateName && this.updatedContent && (this.selectedCommunity.length >0 || this.selectedBcc.length > 0 || this.selectedCc.length>0) && this.cmSubject && this.maskingMsg) {
      this.disableEmailButton = false;
    } else {
      this.disableEmailButton = true;
    }
  
}

  validationForUpdateButton(): void {
    this.disableUpdateButton = true; // Reset the button state
    if (this.selectedTemplate?.templateName && this.updatedContent && this.selectedUsers.length > 0) {
    if (this.selectedTemplate?.templateName && this.updatedContent && this.selectedUsers.length > 0) {
      if (this.prevMessageContent != this.updatedContent || this.checkForDataChange()) {
        this.disableUpdateButton = false;
      }
    }
  }
}

  checkForDataChange(): boolean {
    const msidArr = this.selectedUsers.map(user => user.msid);
    const currentMsidArr = this.selectedTemplate.accessId ? this.selectedTemplate.accessId.split(',') : [];
    // Check if the message content or selected users have changed
    return !this.arraysEqual(msidArr, currentMsidArr);
  }

  private arraysEqual(arr1: string[], arr2: string[]): boolean {
    if (arr1.length !== arr2.length) {
      return false;
    }
    return arr1.every((value, index) => value === arr2[index]);
  }

  validateButtons(): void {
    if (this.createNewTemplateFlag) {
      this.validationForCreateButton();
    } else {
      this.validationForEmailButton();
      this.validationForUpdateButton();
    }
  }

  getUpdatedContent(ev): void {
    this.updatedContent = ev as string; // Update the message content with the emitted value
    this.validateButtons(); // Validate buttons after content update
  }


}
